import { ConoceMasB } from "../components/Banner/conoceMasB";
import FAQComponent from "../components/Faqs/preguntas";

export default function ConoceMas() {
	return (
		<>
			<head>
				<title>Directorio UNIQ | Conoce más aquí</title>
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<link rel="icon" href="/favicon.ico" />
			</head>
			<div>
				<ConoceMasB />
				<FAQComponent />
			</div>
		</>
	);
}
